import React from 'react';
import FleetDevices from '../components/FleetDevices';

const Fleet: React.FC = () => (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <h1 style={{ marginTop: 0 }}>Fleet</h1>
        <FleetDevices />
    </div>
);

export default Fleet;
